//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('labourPositions', {
//        templateUrl: 'views/components/views/labourPositions/labourPositions.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'labourPositionsService', 'labourPositionService', 'equipmentEditService', 'ttGridFactory', 'rememberService', function ($stateParams, stateService, utilityService, labourPositionsService, labourPositionService, equipmentEditService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            let variableNames = {
//                factory_id: '',
//                workgrp_keyno: ''
//            };

//            vm.model = {
//                gridLabourPositionsReady: false,
//                gridProductionOrdersReady: false,
//                bgLabourPositionsMain: {
//                    selected: 'LABOURS',
//                    buttons: [
//                        { id: 'LABOURS', label: 'gb_labourpositions_main_labours', color: 'primary', onClick: function () { vm.model.bgLabourPositionsMain.selected = 'LABOURS'; } },
//                        { id: 'POS', label: 'gb_labourpositions_main_pos', color: 'primary', onClick: function () { vm.model.bgLabourPositionsMain.selected = 'POS'; } }
//                    ]
//                },
//                workGroupButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('workgrp_keyno') }
//                ],
//                setting: {},
//                selectListFactories: [],
//                selectListWorkGroups: []
//            };

//            vm.gridLabourPositions = new ttGridFactory({
//                rememberId: 'w_labourpositions_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'labourpositions_new',
//                    text: 'labourpositions_new',
//                    func: () => {
//                        stateService.go('labourposition', {
//                            labourposition_keyno: '0',
//                            argtype: vm.model.setting.argtype,
//                            argvalue: vm.model.setting.argvalue
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);

//            vm.gridProductionOrders = new ttGridFactory({
//                rememberId: 'w_labourpositions_active_pojob_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await labourPositionsService.getLabourPositions({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            async function loadSelectFactories() {
//                vm.model.selectListFactories = await labourPositionService.listSelectFactories();
//            }

//            async function loadSelectWorkGroups() {
//                if (utilityService.validateParmsValue(vm.model.setting.factory_id, true) !== true) return;

//                return vm.model.selectListWorkGroups = await equipmentEditService.listSelectWorkGroups({ factory_id: vm.model.setting.factory_id });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGridLabourPositions() {
//                vm.gridLabourPositions.dataTask.loadData = {
//                    method: 2562,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridLabourPositionsReady = true;

//                if (vm.gridLabourPositions.gridfunc !== null) vm.gridLabourPositions.gridfunc.read();
//            }

//            async function loadGridProductionOrders() {
//                vm.gridProductionOrders.dataTask.loadData = {
//                    method: 2890,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridProductionOrdersReady = true;

//                if (vm.gridProductionOrders.gridfunc !== null) vm.gridProductionOrders.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'factory_id':
//                    case 'workgrp_keyno':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region MULTI CLEAR FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'workgrp_keyno':
//                        vm.model.setting.workgrp_keyno = '0';

//                        Promise.all([
//                            rememberFunc('workgrp_keyno')
//                        ]).then(() => {
//                            if (vm.model.bgLabourPositionsMain.selected === 'LABOURS') {
//                                loadGridLabourPositions();
//                            } else {
//                                loadGridProductionOrders();
//                            }

//                            Promise.resolve();
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI CLEAR FUNCTION

//            // #region BUTTON GROUP SINGLE FUNCTION

//            vm.selectBgLabourPositionsMain = function (value) {
//                vm.model.bgLabourPositionsMain.selected = value;

//                if (vm.model.bgLabourPositionsMain.selected === 'LABOURS') {
//                    loadGridLabourPositions();
//                } else {
//                    loadGridProductionOrders();
//                }
//            }

//		    // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'factory_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.factory_id) !== true) return;

//                        vm.model.setting.factory_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.factory_id, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('factory_id'),
//                            loadSelectWorkGroups()
//                        ]).then(() => {
//                            if (vm.model.bgLabourPositionsMain.selected === 'LABOURS') {
//                                loadGridLabourPositions();
//                            } else {
//                                loadGridProductionOrders();
//                            }

//                            Promise.resolve();
//                        });
//                        break;
//                    case 'workgrp_keyno':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.workgrp_keyno) !== true) return;

//                        vm.model.setting.workgrp_keyno = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.workgrp_keyno, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('workgrp_keyno')
//                        ]).then(() => {
//                            if (vm.model.bgLabourPositionsMain.selected === 'LABOURS') {
//                                loadGridLabourPositions();
//                            } else {
//                                loadGridProductionOrders();
//                            }

//                            Promise.resolve();
//                        });
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadSelectFactories();

//                return Promise.all([
//                    loadSelectWorkGroups()
//                ]).then(() => {
//                    if (vm.model.bgLabourPositionsMain.selected === 'LABOURS') {
//                        loadGridLabourPositions();
//                    } else {
//                        loadGridProductionOrders();
//                    }

//                    Promise.resolve();
//                });
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
